import styled from "@emotion/styled"
import { spacingFluidMd, spacingFluidXl, spacingStaticXs } from "@porsche-design-system/components-react/emotion"
import { Grid } from "../grid/Grid"
import { GridItem } from "../grid/GridItem"
import { Skeleton } from "../skeleton"

export const FinancingSkeleton = () => (
	<Grid $columnGap={{ base: spacingFluidMd, s: spacingFluidXl }}>
		<GridItem size={{ base: 12, m: 4 }}>
			<StyledSkeletonHeading size="md" />
			<Skeleton.List withHeader />
		</GridItem>
	</Grid>
)

const StyledSkeletonHeading = styled(Skeleton.Heading)`
	width: 150px;
	margin: 0 0 ${spacingStaticXs};
`
